// Simpleton hash function courtesy of Gemini 2.5 pro
export const stringToColor = str => '#' + (str?.split('')?.reduce((h, c) => h = c.charCodeAt(0) + ((h << 5) - h), 0) & 0xFFFFFF).toString(16).padStart(6, '0'); 